let canfTest = angular.module("canf.test", [])
let TestCtrl = function($rootScope) {
  $rootScope.hideLoader = true
  console.log("TestCtrl")
}
TestCtrl.$inject = ["$rootScope"]
canfTest.controller("TestCtrl", TestCtrl)
